module.exports = __webpack_public_path__ + "static/media/cnh-verso.da32e61d.svg";